/**
 * Lenis smooth scroll toggle (client + server; NEXT_PUBLIC_* is inlined at build time).
 *
 * Disable site-wide: set in `.env.local`:
 *   NEXT_PUBLIC_LENIS_SMOOTH_SCROLL=false
 * (also accepts "0" or "off".)
 *
 * @see https://github.com/darkroomengineering/lenis/blob/main/packages/react/README.md
 */
export function isLenisSmoothScrollEnabled(): boolean {
  const raw = process.env.NEXT_PUBLIC_LENIS_SMOOTH_SCROLL;
  if (raw == null || raw === "") return true;
  const v = raw.trim().toLowerCase();
  if (v === "0" || v === "false" || v === "off" || v === "no") return false;
  return true;
}
